<div id="content" class="allcp-form without-subnavbar" ng-controller="NewOrderController" ng-init="init()">
	<div ng-include="'modules/company/menus/order_menu.html'"></div>
    <form name="newWork" ng-submit="newOrder(newWork.$valid)">
        <div class="row">
            <div class="col-md-6 pr-0">
                <div class="panel-body" style="height:auto">
                    <div class="two-address">
                        <div class="form-group floating">
                            <select ng-model="newOrderData.company_customer_id" class="form-control" required>
                                <!-- ng-options="o.id as o.full_name for o in data.workers track by $index" -->
                                <option value="">Select Partner</option>
                                <option value="{{ customer.id }}"
                                    ng-repeat="customer in orderData.customers track by $index" ng-selected="newOrderData.company_customer_id == customer.id">
                                    {{ customer.customer_name }}
                                </option>
                            </select>
                            <label>Partner</label>
                        </div>

                        <div class="form-group floating" ng-class="{ 'has-error': newWork.name.$invalid && newWork.name.$touched }">
                            <div 
                                angucomplete-alt 
                                name="name" 
                                class="location-name"
                                ng-model="newOrderData.location.name" 
                                placeholder="Full Name" 
                                pause="100" 
                                selected-object="locationSelectedCustomer" 
                                remote-url="{{ 'api/find-location?company_customer_id='+newOrderData.company_customer_id+'&s=' }}" 
                                remote-url-data-field="locations" 
                                search-fields="name,phone_number,address" 
                                title-field="name" 
                                description-field="address" 
                                minlength="1" 
                                input-class="form-control input-md" 
                                match-class="highlight" 
                                field-required="true">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col pr-1">
                                <div class="form-group floating" ng-class="{ 'has-error': newWork.email.$invalid }">
                                    <input type="text" ng-model="newOrderData.location.email" placeholder="Email" class="form-control input-md">
                                    <label>Email</label>
                                </div>
                            </div>
                            <div class="col-2 pr-1">
                                <div class="form-group floating">
                                    <!-- <bc-phone-number name='phone_number' ng-model='newOrderData.location.phone_number' default-country='us' preferred-countries='us gb ca' ng-required="true"></bc-phone-number> -->
                                    <input 
                                        type="text" 
                                        class="form-control md" 
                                        ng-init="countryCode = '+1'"
                                        ng-model="countryCode" 
                                        ng-required="true">
                                    <label>Code</label>
                                </div>
                            </div>
                            <div class="col pl-1">
                                <div class="form-group floating">
                                    <!-- <bc-phone-number name='phone_number' ng-model='newOrderData.location.phone_number' default-country='us' preferred-countries='us gb ca' ng-required="true"></bc-phone-number> -->
                                    <input type="text" class="form-control md " ui-mask="(999) 999-9999" ui-mask-placeholder=" " ui-mask-placeholder-char=" " ng-model="newOrderData.location.phone_number" ng-required="true">
                                    <label>Phone</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group floating" ng-class="{ 'has-error': newOrderData.location.$invalid }">
                            <input google-place ng-model="newOrderData.location.address" ng-change="locationSelectedCustomer(newOrderData.location.address,'search')" id="googlePlaceInput" class="form-control input-md " placeholder="Street address" name="address" required />
                            <label>Street address</label>
                        </div>
                        <div class="form-group floating">
                            <input type="text" ng-model="newOrderData.location.address_two" placeholder="Apartment, Suite, Building (Optional)" class="form-control input-md">
                            <label>Apartment, Suite, Building (Optional)</label>
                        </div>
                        <div class="row">
                            <div class="col pr-1">
                                <div class="form-group floating">
                                    <input type="text" ng-model="newOrderData.location.city" required placeholder="City" class="form-control input-md" required>
                                    <label>City</label>
                                </div>
                            </div>
                            <div class="col pl-1 pr-1">
                                <div class="form-group floating">
                                    <select ng-model="newOrderData.location.state" class="form-control">
                                        <option value="">Select State</option>
                                        <option value="{{ state.name }}" ng-repeat="state in states track by $index">{{ state.name }}</option>
                                    </select>
                                    <label>State</label>
                                </div>
                            </div>
                            <div class="col pl-1">
                                <div class="form-group floating">
                                    <input type="text" ng-model="newOrderData.location.zipcode" placeholder="Zip Code" class="form-control input-md" required>
                                    <label>Zip Code</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group floating">
                            <!-- <textarea rows="" cols="" ng-model="newOrderData.special_value" placeholder="Special Instructions (Optional)" class="form-control input-md"></textarea> -->
                            <input type="text" ng-model="newOrderData.special_value" placeholder="Special Instructions (Optional)" class="form-control input-md">
                            <label>Special Instructions (Optional)</label>
                        </div>
                        <div class="form-group floating">
                            <!-- <textarea rows="" cols="" ng-model="newOrderData.name" placeholder="Product Details (Optional)" class="form-control input-md"></textarea> -->
                            <input type="text" ng-model="newOrderData.name" placeholder="Product Details (Optional)" class="form-control input-md">
                            <label>Product Details (Optional)</label>
                            <!-- <span class="input-group-addon danger">
                                    <a href="#" class="hint--medium hint--top-left" aria-label="You need to enter details about the contents of the cargo."><i class="fa fa-question-circle"></i> </a>
                                </span> -->
                        </div>

                        <div class="form-group floating">
                            <select ng-model="newOrderData.work_type" class="form-control" 
									ng-options="option.id as option.name for option in orderData.workTypes | filter:{ name: '!Parcel'}"
                                    ng-change="setOrderDate(newOrderData.work_type)">
                                <option value="">Select Type</option>
                            </select>
                            <label>Delivery Type</label>
                        </div>
                        
                        <div class="row" ng-repeat="item in newOrderData.items">
                            <div class="col pr-1">
                                <div class="form-group floating" ng-class="{ 'has-error': newWork.weight.$invalid || newWork.piece.$invalid }">
                                    <input type="number" ng-model="item.weight" string-to-number placeholder="Weight" class="form-control input-md ">
                                    <label>Weight (lb)</label>
                                </div>
                            </div>
                            <!-- <div class="col pl-1">
                                <div class="form-group floating" ng-class="{ 'has-error': newWork.piece.$invalid || newWork.piece.$invalid }">
                                    <input type="number" required ng-model="item.dimension" string-to-number ng-required="!item.weight" placeholder="Dimensions" class="form-control input-md ">
                                    <label>Dimensions</label>
                                </div>
                            </div> -->
                            <div class="col pl-1">
                                <a href="#" class="hod-button blue" ng-if="$index == 0" ng-click="addBox()">Add more</a>
                                <a href="#" class="hod-button red" ng-if="$index > 0" ng-click="removeBox($index)">Remove box or bag</a>
                            </div>
                        </div>

                        <div ng-if="newOrderData.work_type === 3">
                            <h4>Products</h4>
                            <div class="row" ng-repeat="item in newOrderData.lines">
                                <div class="col-6 pr-1">
                                    <div class="form-group floating">
                                        <input type="text" ng-model="item.name" placeholder="Name" class="form-control input-md ">
                                        <label>Name</label>
                                    </div>
                                </div>
                                <div class="col pl-1">
                                    <div class="form-group floating">
                                        <input type="number" required ng-model="item.qty" string-to-number placeholder="Qty" class="form-control input-md ">
                                        <label>Qty</label>
                                    </div>
                                </div>
                                <div class="col pl-1">
                                    <div class="form-group floating">
                                        <input type="number" required ng-model="item.price" step="0.01" string-to-number placeholder="Price" class="form-control input-md ">
                                        <label>Price</label>
                                    </div>
                                </div>
                                <div class="col pl-1">
                                    <a href="#" class="hod-button orange" ng-if="$index == 0" ng-click="addLine()">Add more</a>
                                    <a href="#" class="hod-button red" ng-if="$index > 0" ng-click="removeLine($index)">Remove Product</a>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row">
                            <div class="col-8" ng-if="newOrderData.flexible_date == 0">
                                <label>Delivery Time</label>
                                <div class="form-group">
                                    <!-- <input id="datetimepicker" 
                                        date-range-picker
                                        placeholder="Delivery Date"
                                        type="text" 
                                        class="form-control  input-md" 
                                        ng-model="newOrderData.scheduled_time"
                                        options="{drops: 'up', singleDatePicker: true, locale: { format: 'MM/DD/YYYY' } }"
                                        autocomplete="off"
                                        required> -->
                                    <input id="order_date" type="text" class="form-control input-md" value="" ng-model="newOrderData.scheduled_time" required>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group">
                                    <label>Flexible Date</label>
                                    <div class="radio-custom radio-info mb15">
                                        <input type="radio" name="types" id="yes" ng-model="newOrderData.flexible_date" ng-change="newOrderData.scheduled_time = null;" ng-value="1">
                                        <label for="yes" class="pt5">Yes</label>
                                        <input type="radio" name="types" id="no" ng-model="newOrderData.flexible_date" ng-value="0" checked ng-checked="true">
                                        <label for="no" class="pt5">No</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-md-2 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.location.building_number" placeholder="Bina No" class="form-control input-md ">
                            </div>
                        </div>

                        <div class="col-md-2 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.location.apartment_number" placeholder="Daire No" class="form-control input-md ">
                            </div>
                        </div> -->
                        <!-- <div class="col-md-6 pln prn">
                            <div class="form-group">
                                <input type="text" ng-model="newOrderData.location.directions" placeholder="Adres Tarifi" class="form-control input-md">
                            </div>
                        </div> -->
                    </div>
                    <div class='row'>
                        <div class="col-md-12">
                            <button type="button" ng-if="!newOrderData.id" ng-click="submitNewOrder()" class="btn btn-primary" ng-disabled="disabledBtn">
                                Create
                            </button>
                            <button type="button" ng-if="newOrderData.id" ng-click="updateOrder()" class="btn btn-primary" ng-disabled="disabledBtn">
                                Update
                            </button>
                            
                            <button type="submit" id="newWorkBtn" class="hidden"></button>
                            <a href="#" ng-if="!newOrderData.id" data-toggle="modal" class="btn btn-outline pull-right" data-target="#importOrderList">
                                Import Order With Excel
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 pl-0">
                <div id="customerMapOrder"></div>
                <!-- <div class="form-group p5" ng-class="{ 'has-error': newOrderData.work_type.$invalid }">
                        <div class="radio-custom radio-primary pln radio-inline mb5 mln" ng-repeat="item in orderData.workTypes">
                            <input type="radio" id="{{ item.id }}" value="{{ item.id }}" name="type" ng-model="newOrderData.work_type" required >
                            <label for="{{ item.id }}" class="pt5">{{ item.name }}</label>
                        </div>
                    </div> -->
                <!-- <div class="form-group mt10">
                        <label class="control-label mb10">Ödeme Türü : </label> <br>
                        <div class="radio-custom ">
                            <input type="radio" id="offline" name="order_payment" ng-value="'offline'" ng-model="newOrderData.order_payment">
                            <label for="offline" class="pt5">Ödendi</label>
                        </div>

                        <div class="radio-custom ">
                            <input type="radio" id="payable" name="order_payment" ng-value="'payable'" ng-model="newOrderData.order_payment">
                            <label for="payable" class="pt5">Karşıdan Ödemeli</label>
                        </div>
                    </div> -->
                <!-- <div class="col-md-12 pln prn">
                        <div class="form-group" ng-class="{ 'has-error': newWork.price.$invalid }">
                            <label class="control-label mb10">Ödeme Tutarı</label>
                            <input type="number" min="1" max="999" ng-model="newOrderData.price" required placeholder="Alınacak Ödeme Tutarı" step="any" class="form-control input-md ">
                        </div>
                    </div> -->
                <!-- <div class="col-md-6 pln prn"> -->
                <!-- </div> -->
                <!-- <div class="col-md-6 pln prn">
                        <div class="form-group" ng-class="{ 'has-error': newWork.special_value.$invalid }">
                            <label class="control-label mb10">Kargo İçeriği</label>
                            <input type="text" ng-model="newOrderData.special_value" placeholder="Product Details" class="form-control input-md">
                        </div>
                    </div> -->
            </div>
        </div>
    </form>
    <div class="modal info-box" id="successBox" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="success-box">
                        <img src="/img/sucess-icon.svg">
                        <h3>
                            {{ proccesCount > 1 ? 'Orders' : 'Order' }} Successfully {{ procces == 'update' ? 'Updated' : 'Created' }}.
                        </h3>
                        <a href="#" class="btn" data-dismiss="modal">
                            Done
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
